import { useState } from "react";
import { themeCollections } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

export default function ThemeCollection() {
  const [activeKey, setActiveKey] = useState(themeCollections[0].key);

  return (
    <section id="themes" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="主题合集"
          title="按当下心情，走进不同的伦理现场"
          desc="同样是探讨人性，切入点可以完全不同。切换下面的主题标签，看看每个方向里最值得一看的作品与它们各自的角度。"
        />

        <div className="mt-7 flex w-full flex-wrap gap-2 rounded-full border border-background-200 bg-background-100 p-1 md:w-fit">
          {themeCollections.map((theme) => {
            const active = theme.key === activeKey;
            return (
              <button
                key={theme.key}
                type="button"
                onClick={() => setActiveKey(theme.key)}
                className={
                  active
                    ? "whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2 text-sm font-label font-medium text-background-50"
                    : "whitespace-nowrap rounded-full px-5 py-2 text-sm font-label text-foreground-700 transition-colors hover:text-foreground-950"
                }
              >
                {theme.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8">
          {themeCollections.map((theme) => (
            <div
              key={theme.key}
              className={theme.key === activeKey ? "block" : "hidden"}
            >
              <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.05fr_1fr] lg:items-center">
                <div className="h-56 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
                  <img
                    src={theme.image}
                    alt={`${theme.label}主题影片氛围示意`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div>
                  <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-label font-medium text-accent-800">
                    <i className="ri-hashtag"></i>
                    {theme.label}
                  </span>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
                    {theme.intro}
                  </p>
                </div>
              </div>

              <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
                {theme.films.map((film) => (
                  <article
                    key={film.title}
                    className="rounded-lg border border-background-200 bg-background-100/60 p-5"
                  >
                    <div className="flex items-baseline justify-between gap-3">
                      <h3 className="font-heading text-base font-bold text-foreground-950">
                        {film.title}
                      </h3>
                      <span className="shrink-0 text-xs font-label text-foreground-500">
                        {film.year}
                      </span>
                    </div>
                    <p className="mt-1 text-xs font-label text-foreground-500">
                      导演 · {film.director}
                    </p>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                      {film.note}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}